import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenEntityDeleteComponent } from "./components/loren-entity-delete/loren-entity-delete.component";
import { LorenCardModule } from "../loren-card/loren-card.module";

@NgModule({
  declarations: [LorenEntityDeleteComponent],
  exports: [LorenEntityDeleteComponent],
  imports: [
    CommonModule,
    LorenCardModule,
    MatButtonModule,

    RouterModule,
    TranslocoModule,
    MatButton,
  ],
})
export class LorenEntityDeleteCardModule {}
